import storage from './storage';

const KEY = 'crm_import_history';
const MAX = 200;

export const importHistoryService = {
  getAll() { return storage.get(KEY, []); },
  add(entry) {
    const history = this.getAll();
    storage.set(KEY, [{ ...entry, id: entry.id || Date.now() }, ...history].slice(0, MAX));
  },
  remove(id) {
    storage.set(KEY, this.getAll().filter(h => String(h.id) !== String(id)));
  },
  update(id, changes) {
    storage.set(KEY, this.getAll().map(h => String(h.id) === String(id) ? { ...h, ...changes } : h));
  },
  clear() { storage.set(KEY, []); },
};
